document.addEventListener("DOMContentLoaded", function() {
  const rotatingText = document.querySelector('.td-rotating-text');

  if (rotatingText) {
    const keywords = rotatingText.getAttribute('data-keywords').split(',');
    let currentIndex = 0;
    let rotatingTextInterval;

    function rotateText() {
      rotatingText.classList.add('fade-out');
      setTimeout(() => {
        rotatingText.textContent = keywords[currentIndex];
        rotatingText.classList.remove('fade-out');
        currentIndex = (currentIndex + 1) % keywords.length;
      }, 600);
    }

    rotatingTextInterval = setInterval(rotateText, 2000);

    // Cleanup interval on page unload
    window.addEventListener('unload', function() {
      clearInterval(rotatingTextInterval);
    });

    // Assuming .fade-out class is defined in CSS with appropriate transition
    rotatingText.addEventListener('transitionend', function() {
      if (rotatingText.classList.contains('fade-out')) {
        rotatingText.classList.add('fade-in');
      } else {
        rotatingText.classList.remove('fade-in');
      }
    });
  }
});